import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../../components/ui/card';
import UserMetrics from './UserMetrics';
import UserRoleDistribution from './UserRoleDistribution';
import ActiveUsersChart from './ActiveUsersChart';
import UserOrganizationStatsCards from './UserOrganizationStatsCards';
import InvitedUsersStats from './InvitedUsersStats';

const UserAndOrganizationActivity = () => {
  return (
    <div className="innerpage detailed-page">
      <div className="w-full">
        <div className="mb-6">
          <h4 className="text-lg font-semibold mb-0">
            User & Organization Activity
          </h4>
          <p className="text-muted-foreground text-sm mb-0">
            Statistics on user engagement, registrations, and distribution.
          </p>
        </div>

        {/* Stats Cards */}
        <UserOrganizationStatsCards />

        {/* Charts */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
          <Card className="shadow-sm border-0">
            <CardHeader>
              <CardTitle className="text-base font-bold">Registration Analytics</CardTitle>
              <CardDescription className="text-sm">
                User acquisition metrics
              </CardDescription>
            </CardHeader>
            <CardContent>
              <UserMetrics />
            </CardContent>
          </Card>
          <Card className="shadow-sm border-0 h-full">
            <CardHeader>
              <CardTitle className="text-base font-bold">User Role Distribution</CardTitle>
              <CardDescription className="text-sm">
                Current user composition
              </CardDescription>
            </CardHeader>
            <CardContent>
              <UserRoleDistribution />
            </CardContent>
          </Card>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
          <Card className="shadow-sm border-0">
            <CardHeader>
              <CardTitle className="text-base font-bold">Active Users</CardTitle>
              <CardDescription className="text-sm">
                User engagement metrics
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ActiveUsersChart />
            </CardContent>
          </Card>
          <InvitedUsersStats />
        </div>
      </div>
    </div>
  );
};

export default UserAndOrganizationActivity;
